var exports = {
  "iE": "xaee3c4fa--d8c85c--wrapper",
  "x9": "xaee3c4fa--d8c85c--block-reason-wrapper",
  "$0": "xaee3c4fa--d8c85c--title-wrapper",
  "E3": "xaee3c4fa--d8c85c--author-wrapper",
  "F$": "xaee3c4fa--d8c85c--details-wrapper",
  "PC": "xaee3c4fa--d8c85c--moderation-wrapper",
  "K$": "xaee3c4fa--d8c85c--main-image-wrapper",
  "RJ": "xaee3c4fa--d8c85c--description-wrapper",
  "o5": "xaee3c4fa--d8c85c--content-wrapper",
};

module.exports = exports;
